"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteIcon = exports.label = exports.tag = void 0;

var _react = require("@emotion/react");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  width: 42px;\n  height: 100%;\n  padding: 10px 12px 10px 12px;\n  cursor: ", ";\n  border-radius: ", ";\n  border: 1px solid transparent;\n  > svg {\n    color: ", ";\n  }\n\n  &:focus {\n    border: 1px solid ", ";\n    border-radius: ", ";\n    box-shadow: 0 0 0 2px ", "26;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  line-height: ", ";\n  padding: 0 ", "px 0 16px;\n  color: ", ";\n  cursor: default;\n  user-select: none;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  width: fit-content;\n  height: 40px;\n  background-color: ", ";\n  opacity: ", ";\n  color: ", ";\n  border-radius: ", ";\n  border: 1px solid transparent;\n  &:hover {\n    background-color: ", ";\n  }\n  &:focus {\n    border: 1px solid ", ";\n    border-radius: ", ";\n    box-shadow: 0 0 0 2px\n      ", "26;\n  }\n\n  &:not(:first-of-type) {\n    margin: 0 0 0 8px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var radius = '20px';

var tag = function tag(disabled) {
  return function (theme) {
    return (0, _react.css)(_templateObject(), theme.colors.primary.lightest, disabled ? 0.5 : 1, theme.colors.primary.medium, radius, disabled ? theme.colors.primary.lightest : theme.colors.primary.lighter, disabled ? 'transparent' : theme.colors.primary.medium, radius, disabled ? 'transparent' : theme.colors.primary.medium);
  };
};

exports.tag = tag;

var label = function label(isIconDisplayed) {
  return function (theme) {
    return (0, _react.css)(_templateObject2(), radius, isIconDisplayed ? 0 : 16, theme.colors.primary.medium);
  };
};

exports.label = label;

var deleteIcon = function deleteIcon(disabled) {
  return function (theme) {
    return (0, _react.css)(_templateObject3(), disabled ? 'default' : 'pointer', radius, theme.colors.primary.medium, theme.colors.primary.medium, radius, theme.colors.primary.medium);
  };
};

exports.deleteIcon = deleteIcon;